import { createContext } from 'react';

import { EMPTY_PROMISE } from '../../constants';
import { RequestsApi } from './types';

export const RequestsContext = createContext<RequestsApi>({
  platformRequest: EMPTY_PROMISE,
  externalRequest: EMPTY_PROMISE,
});
